import React, { forwardRef, useImperativeHandle, useState } from 'react';
import Modal from 'components/Modal';
import RedeemModalContent from './RedeemModalContent';
import useGetRedeemTracking, { initialFilterRedeemTracking } from 'features/giftCards/services/hooks/useGetRedeemTracking';

export type IRedeemModalRef = {
  open: () => void;
};

type IRedeemModalProps = {};

const RedeemModal = forwardRef<IRedeemModalRef, IRedeemModalProps>(({}, ref) => {
  const [visible, setVisible] = useState(false);
  const { data, filter, loading, setfilter, search } = useGetRedeemTracking();
  const onClose = () => {
    setVisible(false);
    setfilter(initialFilterRedeemTracking);
  };

  useImperativeHandle(ref, () => ({
    open: () => {
      setVisible(true);
      search(filter);
    },
  }));
  return (
    <Modal
      modalTitle='Gift card redeemed'
      visible={visible}
      onClose={onClose}
      hiddenOkButton={true}
      v2
      width={1200}
      noneBodyStyle
      destroyOnClose
    >
      <RedeemModalContent data={data} filter={filter} loading={loading} setfilter={setfilter} search={search} />
    </Modal>
  );
});
RedeemModal.displayName = 'RedeemModal';

export default RedeemModal;
